import { writable } from 'svelte/store'


const stringValue = window.localStorage.getItem('preferences') ?? '{}'
let value
try {
	value = JSON.parse(stringValue)
} catch (error) {
	console.error('Could not parse localStorage preferences')
	value = {}
}

const storeCache = {}

export default function (property, defaultValue) {
	let store = storeCache[property]
	if (store) return store
	store = writable(value[property] ?? defaultValue)
	storeCache[property] = store

	store.subscribe(v => {
		value[property] = v
		window.localStorage.setItem('preferences', JSON.stringify(value))
	})
	return store
}